import React, { Component } from 'react';

import './Modulo.sass'
import PropTypes from 'prop-types';
import { mapearUrlModulo } from '../../../utils';

export default class Modulo extends Component {

    // Retorna a URL de acesso ao módulo
    getUrl() {
        if (this.props.desabilitado) return null;
        
        const urlMapeada = mapearUrlModulo(this.props.url);
        return urlMapeada + '?accessToken=' + this.props.tokenModulo;
    }

    render() {
        return (
            <a href={this.getUrl()} style={{textDecoration: 'none'}}>
                <div className={`${this.props.desabilitado ? 'modulo not-allowed' : 'modulo'}`}
                    style={
                        {
                            backgroundImage: `url(data:image/png;base64,${this.props.img})`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover'
                        }}>
                    <div className="footer">
                        <span className="modulo-name">{this.props.nome}</span>
                        {(this.props.desabilitado &&
                            <i className="lock-icon mdi mdi-lock" />
                        )}
                    </div>
                </div>
            </a>
        );
    }
}

Modulo.propTypes = {
    nome: PropTypes.string,
    img: PropTypes.any,
    urlModulo: PropTypes.string,
    tokenModulo: PropTypes.string,
    desabilitado: PropTypes.bool
}